import { useChat } from '@services/ChatProvider';
import { ChatSidebarExpanded } from './ChatSidebarExpanded';
import { ChatSidebarCollapsed } from './ChatSidebarCollapsed';
import styles from './ChatSidebar.module.scss';

export const ChatSidebar = () => {
	const { isOpen, setIsOpen } = useChat();

	return (
		<aside className={`${styles.chatSidebar} ${isOpen ? styles.expanded : styles.collapsed}`} aria-label="Chat assistant">
			{isOpen ? (
				<ChatSidebarExpanded onCollapse={() => setIsOpen(false)} />
			) : (
				<ChatSidebarCollapsed onExpand={() => setIsOpen(true)} />
			)}
		</aside>
	);
};
